import React, { FC } from 'react';
import { Box, SectionHelper, StarsRatingBar, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials-standalone';
import s from './AddReviewBanner.module.scss';
import { StarsRatingBarProps } from '@wix/design-system/dist/types/StarsRatingBar';
import { IHandleBIGenericClick } from '@common/types';
import {
  ACTIONS,
  useTemplateContext,
} from '@components/Contexts/TemplateContext';

type AddReviewBannerProps = {
  openReviewModal: (openUsingBanner?: boolean) => void;
  handleBiGenericClick?: IHandleBIGenericClick;
};

const AddReviewBanner: FC<AddReviewBannerProps> = ({
  openReviewModal,
  handleBiGenericClick,
}) => {
  const { dispatch, reviewScore } = useTemplateContext();
  const { t } = useTranslation();
  return (
    <Box className={s.addReviewContainer} width="100%">
      <SectionHelper
        appearance="standard"
        title={t('marketplace.template-page.review.add-banner.title')}
        actionText={t('marketplace.template-page.review.add-banner.body')}
        showCloseButton={false}
        fullWidth={true}
        dataHook="new-template-review-banner"
      >
        <Box gap="12px" direction="vertical">
          <Text size="small" secondary>
            {t('marketplace.template-page.review.add-banner.body')}
          </Text>
          <StarsRatingBar
            value={reviewScore}
            onChange={(score: number) => {
              dispatch({
                type: ACTIONS.SET_REVIEW_SCORE,
                score: score as StarsRatingBarProps['value'],
              });
              handleBiGenericClick &&
                handleBiGenericClick({
                  clickType: 'Rate your new template',
                  clickData: { rate: score },
                });
              openReviewModal(true);
            }}
          />
        </Box>
      </SectionHelper>
    </Box>
  );
};

export default AddReviewBanner;
